var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',_vm._l((_vm.calculations),function(calculation,index){return _c('div',{key:index,staticClass:"row relative-position"},[(index)?_c('QSeparator',{staticClass:"separator q-ma-none",attrs:{"color":"primary"}}):_vm._e(),_c('div',{class:[
        'q-pa-md col-4 bg-primary-dark row items-center',
        { 'inset-shadow': !index }
      ]},[(_vm.loading)?_c('QSpinnerDots',{attrs:{"color":"white","size":"16px"}}):_c('span',{class:[
          'text-label text-white',
          { 'text-weight-bold': calculation.bold }
        ]},[_vm._v(" "+_vm._s(calculation.label)+" "),(calculation.information)?_c('SAIInformationPopup',{attrs:{"icon-color":"primary"}},[_c('p',[_vm._v(_vm._s(calculation.information))])]):_vm._e()],1)],1),_c('div',{class:[
        'q-pa-md col-4 row justify-end items-center',
        {
          'text-weight-bold': calculation.bold,
          'inset-shadow': !index,
          'bg-primary-semi-dark text-white': _vm.noSacrificeActive,
          'bg-white': _vm.sacrificeActive
        }
      ]},[(_vm.loading)?_c('QSpinnerDots',{attrs:{"color":_vm.noSacrificeActive ? 'white' : 'grey-8',"size":"16px"}}):_vm._e(),(calculation.negative && !_vm.loading)?_c('span',{class:[
          'text-negative text-weight-medium q-mr-xs',
          { 'text-title': _vm.noSacrificeActive }
        ]},[_vm._v(" – ")]):_vm._e(),(!_vm.loading)?_c('span',{class:{
          'text-weight-bold': calculation.bold,
          'text-title': _vm.sacrificeActive
        }},[_vm._v(" "+_vm._s(_vm._f("currency")(_vm._f("frequency")(Math.abs(calculation.sacrifice),'monthly', _vm.frequency)))+" ")]):_vm._e()],1),_c('div',{class:[
        'q-pa-md col-4 row justify-end items-center shadow',
        {
          'inset-shadow': !index,
          'bg-primary-semi-dark text-white': _vm.sacrificeActive,
          'bg-white': _vm.noSacrificeActive
        }
      ]},[(_vm.loading)?_c('QSpinnerDots',{attrs:{"color":_vm.sacrificeActive ? 'white' : 'grey-8',"size":"16px"}}):(calculation.negative)?_c('span',{class:[
          'text-negative text-weight-medium q-mr-xs',
          { 'text-title': _vm.noSacrificeActive }
        ]},[_vm._v(" – ")]):_vm._e(),(!_vm.loading)?_c('span',{class:{
          'text-weight-bold': calculation.bold,
          'text-title': _vm.noSacrificeActive
        }},[_vm._v(" "+_vm._s(_vm._f("currency")(_vm._f("frequency")(calculation.noSacrifice,'monthly', _vm.frequency)))+" ")]):_vm._e()],1)],1)}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }